import { tw } from "../../styling";
import { SvgIcon } from "../svg-icon";

type Props = {
	open: boolean;
	disabled?: boolean;
};

export const ToggleChevron = ({ open, disabled }: Props) => (
	<div className="flex items-center justify-center print:invisible">
		<div
			className={tw(
				"transition-transform",
				"text-interactive-primary",
				disabled && "text-interactive-disabled",
				open && "-rotate-180",
				!open && "rotate-0",
			)}
		>
			<SvgIcon imageSrc="CHEVRON_DOWN" height={8} />
		</div>
	</div>
);
